import React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { Col, FormControl, FormGroup } from "components/bootstrap";
import { Select } from "components/common";
const OperatorSelector = styled.div(
  ({ theme }) => css`
    margin-bottom: 15px;
    font-size: ${theme.fonts.size.body};
  `
);
const BooleanOperatorSelect = styled(({ isFirstElement: _ignored, ...props }) => /* @__PURE__ */ React.createElement(FormGroup, { ...props }))`
  width: 100px;
  margin-left: ${(props) => props.isFirstElement ? "" : "1em"};
  margin-right: 1em;
`;
const BooleanOperatorSelector = ({
  initialText = "",
  operator,
  onOperatorChange,
  placeholder = void 0
}) => {
  const { t } = useTranslation("event_definitions");
  return /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(OperatorSelector, { className: "form-inline" }, initialText && /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(FormControl.Static, null, initialText, " ")), /* @__PURE__ */ React.createElement(BooleanOperatorSelect, { isFirstElement: !initialText }, /* @__PURE__ */ React.createElement(
    Select,
    {
      className: "boolean-operator",
      placeholder: placeholder != null ? placeholder : t("conditions.boolean_operator"),
      size: "small",
      onChange: onOperatorChange,
      options: [
        { label: t("conditions.all"), value: "&&" },
        { label: t("conditions.any"), value: "||" }
      ],
      value: operator,
      clearable: false
    }
  )), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(FormControl.Static, null, " ", t("conditions.of_the_following_rules")))));
};
export default BooleanOperatorSelector;
